/**
 * @file MinimumDuration.ts
 * @role Keeps a presentation visible for a configured minimum without delaying slow work.
 * @owns Minimum-duration arithmetic and its injectable wait seam.
 * @neverDoes Read or advance GameTicker time.
 */
/** Returns how much longer a presentation must remain visible. */
export function remainingMinimumDurationMs(
  startedAtMs: number,
  minimumDurationMs: number,
  nowMs: number,
): number {
  return Math.max(0, minimumDurationMs - Math.max(0, nowMs - startedAtMs));
}

/** Keeps a presentation visible for a configured minimum without delaying slow loads further. */
export async function waitForMinimumDuration(
  startedAtMs: number,
  minimumDurationMs: number,
  now: () => number = () => performance.now(),
  delay: (durationMs: number) => Promise<void> = (durationMs) =>
    new Promise((resolve) => setTimeout(resolve, durationMs)),
): Promise<void> {
  const remainingMs = remainingMinimumDurationMs(startedAtMs, minimumDurationMs, now());
  if (remainingMs > 0) await delay(remainingMs);
}
